const enterButton = $('.enter__button-js');

if (enterButton.length > 0) {
  enterButton.on('click', function () {
    const form = $(this).closest('.enter');

    form.find('.enter__title').toggleClass('enter__active');
    form.find('.enter__button-js').toggleClass('enter__active');
    form.find('.enter__tab').toggleClass('enter__active');
  });
}